
<div class="range-slider">
    <div class="range-slider__label">confidence</div>
    <input class="range-slider__range" type="range" [value]="sliderVal" min="0" max="100" [disabled]="true">
</div>